import React from 'react';

interface ArrowComponentProps {
  isMobile: boolean;
}

const ArrowComponent: React.FC<ArrowComponentProps> = ({ isMobile }) => {
  return (
    <div
      style={{
        width: isMobile ? '4px' : '64%',
        height: isMobile ? '64%' : '4px',
        backgroundColor: '#7A7A7AF7',
        position: 'relative',
        textAlign: 'center',
        margin: '10px auto',
      }}
    >
      <div
        style={{
          width: '0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: isMobile ? '0 10px 10px 10px' : '10px 10px 10px 0',
          borderColor: isMobile
            ? 'transparent transparent #7A7A7AF7 transparent'
            : 'transparent #7A7A7AF7 transparent transparent',
          position: 'absolute',
          top: isMobile ? '-10px' : '50%',
          left: isMobile ? '50%' : '-10px',
          transform: isMobile ? 'translateX(-50%)' : 'translateY(-50%)',
        }}
      ></div>

      <div
        style={{
          width: '0',
          height: '0',
          borderStyle: 'solid',
          borderWidth: isMobile ? '10px 10px 0 10px' : '10px 0 10px 10px',
          borderColor: isMobile
            ? '#7A7A7AF7 transparent transparent transparent'
            : 'transparent transparent transparent #7A7A7AF7',
          position: 'absolute',
          bottom: isMobile ? '-10px' : 'auto',
          right: isMobile ? '50%' : '-10px',
          transform: isMobile ? 'translateX(50%)' : 'translateY(-50%)',
        }}
      ></div>
    </div>
  );
};

export default ArrowComponent;
